module.exports = __webpack_public_path__ + "img/Proliferation-LICA_PLC.62eb07e5.png";